<!--
  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
  ~ No part of this publication may be reproduced, distributed,
  ~ or transmitted in any form or by any means, including photocopying, recording,
  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
  ~ except in the case of brief quotations embodied in critical
  ~ reviews and certain other noncommercial uses permitted by copyright law.
  ~  author : vhe
  ~  date : 02/03/2021 07:39
  -->

@if (resources()) {
  <div
    class="planning"
    [style.min-width.px]="!onWeek() ? calendarBodyMinWidth : null"
  >
    @if (showResources()) {
      <infl-calendar-horizontal-resources
        [resources]="resources()"
        [resourceTitle]="resourceTitle()"
        (changeDisplay)="generateTasks()"
      ></infl-calendar-horizontal-resources>
    }
    <div class="calendar" [ngClass]="{ onWeek: onWeek(), safari: isSafari }">
      <div class="header" [ngClass]="{ onWeek: onWeek() }">
        @if (showResources()) {
          <div class="sub-header">
            <div class="header-content">SEMAINE {{ weekNumber() }}</div>
          </div>
        }
        <div class="sub-header">
          <div
            class="header-content"
            [style.font-weight]="isCurrentDay ? 'bold' : null"
            [innerHTML]="
              day()
                | customDate: 'DD/MM/YYYY' : translate.currentLang : false
                | uppercase
            "
          ></div>
        </div>
      </div>
      <table
        #tableBody
        class="body"
        [ngStyle]="{
          'min-width.px': !onWeek() ? calendarBodyMinWidth : null,
          'width.px': onWeek() ? calendarBodyWithOnWeek : null,
        }"
      >
        <thead>
          <tr #header>
            @for (time of zones; track time.time) {
              <th class="times" [colSpan]="time.zones.length">
                <div #cellHeader class="cell-header">
                  <ng-container
                    [ngTemplateOutlet]="
                      cellWidth() === 'auto' || cellHeader.clientWidth >= 40
                        ? timeFull
                        : timeLight
                    "
                    [ngTemplateOutletContext]="{ time }"
                  >
                  </ng-container>
                </div>
              </th>
            }
          </tr>
        </thead>
        <tbody
          (mousemove)="onMouseMove($event)"
          (dragenter)="$event.preventDefault()"
          (dragover)="$event.preventDefault()"
          (dragleave)="onDragLeaveTbody()"
        >
          @if (isCurrentDay) {
            <div>
              <div class="hour-line" [ngStyle]="hourLineStyle"></div>
            </div>
          }
          @for (group of resources(); track group.id; let groupIndex = $index) {
            <tr class="group-header-row">
              <td [colSpan]="sectionCount"></td>
            </tr>
            @if (group.isOpened) {
              @for (
                resource of group.tasksGroups;
                track resource.id;
                let resourceIndex = $index
              ) {
                <tr
                  class="resource-row"
                  [ngStyle]="{ height: resource.height + 'px' }"
                  [ngClass]="{
                    'last-child':
                      resourceIndex + 1 === group.tasksGroups.length,
                  }"
                >
                  @for (time of zones; track time.time) {
                    @for (
                      sub of time.zones;
                      track sub;
                      let zoneIndex = $index
                    ) {
                      <td
                        #dayRow
                        inflDayRow
                        class="sub"
                        [ngClass]="{
                          partial: zoneIndex + 1 < time.zones.length,
                          selected: sub.selected && resource === selectedGroup,
                        }"
                        [style.background-color]="
                          teleworkByResource()?.[groupIndex]?.[resourceIndex]
                            ? teleworkService.teleworkColor
                            : '#FFF'
                        "
                        [attr.data-hour]="time.hour"
                        [attr.data-time]="sub.minutes"
                        [attr.data-telework]="
                          teleworkByResource()?.[groupIndex]?.[resourceIndex]
                        "
                        [title]="sub.text"
                        (dblclick)="onDblClick($event)"
                        (mousedown)="
                          selectZone($event, resource, time.hour, sub)
                        "
                        (mouseover)="
                          overZone(
                            $event,
                            time.hour,
                            sub.minutes,
                            sub,
                            resource
                          )
                        "
                        (mouseup)="stop($event)"
                        (dragover)="onDragOver($event, dayRow)"
                        (drop)="
                          onDrop(
                            $event,
                            time.hour,
                            sub.minutes,
                            group.id,
                            resource.id
                          )
                        "
                      ></td>
                    }
                  }
                </tr>
              }
            }
          }
        </tbody>
      </table>
      <div class="tasks">
        @for (task of viewTasks; track task.task.id) {
          <div
            class="task"
            [ngClass]="{ enable: enable() && task.task.enable }"
            [ngStyle]="task.style"
            [draggable]="canDrag() && task.task.enable"
            (click)="onTaskClick($event, task.task)"
            (dblclick)="onTaskClick($event, task.task, true)"
            (mousemove)="onMouseMove($event)"
            (mouseenter)="onHover(task.task)"
            (mouseleave)="onHover(null)"
            (dragstart)="onDragStart(task)"
            (dragend)="enablePointerEvent()"
            (dragover)="allowDrop($event)"
          >
            @if (canResize() && task.task.enable) {
              <div
                class="resize"
                (mousedown)="startResize($event, task.task, 'left')"
              >
                <span class="fal fa-ellipsis-v"></span>
              </div>
            }
            <div
              class="background"
              [style.background-color]="
                task.task.backgroundColor.length === 9
                  ? task.task.backgroundColor
                  : task.task.backgroundColor + 'BF'
              "
            ></div>
            <div class="text">
              @if (task.task.icon) {
                <span class="icon fal fa-{{ task.task.icon }}"></span>
              }
              <div class="text-content" [innerHTML]="task.task.label"></div>
            </div>
            @if (enable()) {
              <div class="remove">
                <span class="fal fa-times"></span>
              </div>
            }
            @if (canResize() && task.task.enable) {
              <div
                class="resize right"
                (mousedown)="startResize($event, task.task, 'right')"
              >
                <span class="fal fa-ellipsis-v"></span>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
}

<ng-template #timeFull let-time="time">
  <span>
    {{ time.hour >= 10 ? time.hour : '0' + time.hour }}:{{
      time.zones[0].minutes >= 10
        ? time.zones[0].minutes
        : '0' + time.zones[0].minutes
    }}
  </span>
</ng-template>
<ng-template #timeLight let-time="time">
  <span class="time-light">
    {{ time.hour }}
  </span>
</ng-template>
